<template>
    <div class="md_toast" v-bind:class="{_show:toastShow}">
            <div class="inner">
                <!--MySelectRoomに追加した場合-->
                <!-- <p>My Select Room に {{BrandName}} を追加しました</p> -->
                <p>{{ message }}</p>
            </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                toastShow: false,
            };
        },
        props: {
            toastFor: String,
        },
        created() {
        },
        methods: {
            setLike() {
            },
        },
        computed: {
            message() {
                var message = '';
                if (this.toastFor == 'setLike') {
                    message = 'LIKEしました';
                    this.toastShow = true;
                    setTimeout(() => {
                        this.toastShow = false;
                    }, 8000)
                    return message;
                } else if (this.toastFor == 'unsetLike') {
                    message = 'LIKEを解除しました';
                    this.toastShow = true;
                    setTimeout(() => {
                        this.toastShow = false;
                    }, 8000)
                    return message;
                } else if (this.toastFor == 'setMySelectRoom') {
                    message = 'My Select Room を 編集しました';
                    this.toastShow = true;
                    setTimeout(() => {
                        this.toastShow = false;
                    }, 8000)
                    return message;
                }
            },
        }
    }
</script>